const region = require('./citys.json');

export default region;
